var THREE         = require("three");
var LocalRotationHandleView  = require("./../abstract/localRotationHandleView.js");
var lib_core      = require("lib-core");

var LocalYRotationView = function (model, editorView, handleId, config) {
    LocalRotationHandleView.call(this, model, editorView, handleId, config);
}

lib_core.inherit(LocalYRotationView, LocalRotationHandleView);

LocalYRotationView.prototype.repositionMesh = function(mesh, position, rotation){
    var matrix = (new THREE.Matrix4())
    matrix.makeRotationFromEuler(new THREE.Euler(rotation.x * Math.PI/180, 0, 0));
    matrix.setPosition( position.toThreejs() );
    mesh.matrix = matrix;
}

LocalYRotationView.prototype.buildMesh = function(radius){
    var obj = new THREE.Object3D();
    obj.matrixAutoUpdate = false;

    var geom = this.buildGeometry(radius).rotateX(Math.PI/2);
    var mesh = new THREE.Mesh(geom, this.material);
    obj.add(mesh);
    return obj
}

 

module.exports = LocalYRotationView;

